<template>
  <div class="newsbox">
    <div class="news-wrap boxshadow1">
      <div class="caption">新闻政策</div>
      <div class="cell">
        <div class="policy_list">
          <div class="wrap">
            <div class="caption_title">相关政策</div>
            <div class="list">
              <ul v-if="policylist && policylist.length > 0">
                <li v-for="(item, index) in policylist" :key="'related-laws-' + index">
                  <router-link class="none" :to="{name: 'LawsShow', params: {id: item.id}}">{{item.title}}</router-link>
                  <router-link class="none" :to="{name: 'LawsShow', params: {id: item.id}}"><span>查看详情</span><svg-icon icon-class="arrow2"></svg-icon></router-link>
                </li>
              </ul>
              <div class="empty" v-else><span>暂无数据</span></div>
            </div>
          </div>
        </div>
        <div class="news_list">
          <div class="wrap">
            <div class="caption_title">相关新闻</div>
            <div class="scroll">
              <div class="list">
                <ul v-if="newslist && newslist.length > 0">
                  <li v-for="(item, index) in newslist" :key="'related-news-' + index">
                    <router-link class="none" :to="{name: 'NewsShow', params: {id: item.id}}">{{item.title}}</router-link>
                    <router-link class="none" :to="{name: 'NewsShow', params: {id: item.id}}"><span>查看详情</span><svg-icon icon-class="arrow2"></svg-icon></router-link>
                  </li>
                </ul>
                <div class="empty" v-else><span>暂无数据</span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapDataState } = createNamespacedHelpers('data')

export default {
  name: 'HsCodeFooter',
  computed: {
    ...mapDataState({
      'newslist': state => state.relatedNews,
      'policylist': state => state.relevantPolicy
    })
  }
}
</script>

<style scoped>
.newsbox{
  margin-bottom: 30px;
}
.news-wrap{
  padding: 14px 10px 14px 18px;
}
.caption{
  font-size: 16px;
  color: #333;
  background: url("~@/assets/images/home/guide.png") 0 center no-repeat transparent;
  background-size: 12px;
  padding-left: 18px;
  margin-bottom: 15px;
  position: relative;
}
.cell{
  position: relative;
}
.policy_list{
  width: 50%;
  border-right: 1px solid #999;
}
.policy_list .wrap{
  padding-right: 15px;
  position: relative;
  height: 100%;
}
.news_list{
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 50%;
}
.news_list .wrap{
  padding-left: 15px;
  position: relative;
  height: 100%;
}
.caption_title{
  color: #656565;
  font-size: 15px;
  font-weight: bold;
  padding-left: 18px;
  margin-bottom: 10px;
}
.list{
  padding-left: 18px;
  padding-right: 18px;
}
.list li{
  position: relative;
  padding-right: 130px;
  padding-bottom: 6px;
  border-bottom: 1px solid #eee;
  margin-bottom: 16px;
}
.list li:last-child{
  border: 0 none;
}
.list li a{
  color: #666;
  font-size: 15px;
  display: block;
  cursor: pointer;
}
.list li a:first-child{
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.list li a:last-child{
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  font-size: 13px;
  padding-bottom: 6px;
}
.list li a:last-child span{
  position: relative;
  padding-right: 2px;
}
.list li a:hover{
  text-decoration: none;
  color: #0470e3;
}
.scroll{
  position: absolute;
  top: 31px;
  right: 0;
  left: 18px;
  bottom: 0;
  overflow-x: hidden;
  overflow-y: auto;
}
.scroll::-webkit-scrollbar-track-piece {
  background: transparent;
}
.scroll::-webkit-scrollbar{
  width: 4px;
}
.scroll::-webkit-scrollbar-thumb{
  background: #e1e1e1;
  border-radius: 20px;
}
.empty{
  height: 214px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ccc;
  font-size: 15px;
}
.empty span{
  margin-top: -30px;
}
</style>


// WEBPACK FOOTER //
// src/components/query/zh-CN/HsCodeFooter.vue